/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringweek1Inputs */

const en_recurringweek1 = /** @type {(inputs: Recurringweek1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`week`)
};

const de_recurringweek1 = /** @type {(inputs: Recurringweek1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche`)
};

/**
* | output |
* | --- |
* | "week" |
*
* @param {Recurringweek1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringweek1 = /** @type {((inputs?: Recurringweek1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringweek1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringweek1(inputs)
	return de_recurringweek1(inputs)
});
export { recurringweek1 as "recurringWeek" }